// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Other
import { colors } from 'common/styles/style-constants';

// Component
const SunriseSvg = ({ height, margin, width }) => (
  <SvgContainer
    color={colors.white}
    height={height}
    margin={margin}
    width={width}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="31"
      viewBox="0 0 34 31"
      fill="#FCFBFC"
      role="presentation"
    >
      <g fillRule="evenodd">
        <path
          id="a"
          d="M19 2a2 2 0 10-4 0v2a2 2 0 104 0V2zm9.394 6.536c.808-.81.808-2.12 0-2.93a2.074 2.074 0 00-2.93 0l-.858.86a2.071 2.071 0 002.93 2.928l.858-.858zm-22.788 0a2.074 2.074 0 010-2.93 2.074 2.074 0 012.93 0l.858.86a2.071 2.071 0 01-2.93 2.928l-.857-.858zM2 19a2 2 0 110-4h2a2 2 0 110 4H2zm28 0a2 2 0 010-4h2a2 2 0 110 4h-2zm-13.5 7.07A23.687 23.687 0 0131.02 31c.344-.41.67-.836.98-1.276C27.867 26.164 22.443 24 16.5 24 10.554 24 5.13 26.164 1 29.724c.307.44.635.865.98 1.276a23.683 23.683 0 0114.52-4.93zm1-4.066c2.33 0 4.577.35 6.7.996a8.733 8.733 0 001.8-5.33C26 12.88 22.195 9 17.5 9S9 12.88 9 17.67c0 2.01.673 3.86 1.8 5.33a22.969 22.969 0 016.7-.996z"
        />
      </g>
    </svg>
  </SvgContainer>
);

SunriseSvg.propTypes = {
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default SunriseSvg;
